webpackJsonp([1],{

/***/ "+KtI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assets_vue__ = __webpack_require__("WpRd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbabec2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assets_vue__ = __webpack_require__("gbV2");
function injectStyle (ssrContext) {
  __webpack_require__("UQuu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Assets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbabec2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Assets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6/c+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Asuo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__("rOBC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e7983f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__("ZP1w");
function injectStyle (ssrContext) {
  __webpack_require__("FK31")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56e7983f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e7983f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FK31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H+s4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = signin_browser;
/* harmony export (immutable) */ __webpack_exports__["d"] = signin;
/* harmony export (immutable) */ __webpack_exports__["f"] = signout_browser;
/* harmony export (immutable) */ __webpack_exports__["a"] = get_assets;
/* harmony export (immutable) */ __webpack_exports__["b"] = get_paths;
/* harmony export (immutable) */ __webpack_exports__["c"] = save_current_time;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__storage__ = __webpack_require__("TsL6");





/* eslint-disable camelcase */



var error_kinds = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_freeze___default()({
  HTTP_ERROR: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default()('httpError'),
  JSON_ERROR: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default()('JSONError'),
  API_ERROR: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default()('ApiError'),
  NO_ERROR: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default()('NoError'),
  UNDEFINED_ERROR: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default()('UndefinedError')
});

function create_srv_error(srv_error) {
  srv_error.type = 'SRV_ERROR';

  // INTENTION: Gæta þess að kind sé alltaf til staðar.
  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(error_kinds).every(function (kind) {
    return srv_error.kind !== kind;
  }) === true) {
    srv_error.kind = error_kinds.UNDEFINED_ERROR;
  }

  // INTENTION: Búa til villuboð, út frá villukóða frá vefþjónustu.
  var des = '';
  switch (srv_error.kind) {
    case error_kinds.HTTP_ERROR:
      des = 'Netsamskipti gengu ekki.';
      break;
    case error_kinds.JSON_ERROR:
      des = 'Samskipti við netþjón voru óeðlileg.<br>Json villa!';
      break;
    case error_kinds.API_ERROR:
      switch (srv_error.error_code) {
        case 'SIGNIN_EXCEPTION':
          des = 'Innskráning tókst ekki.';
          break;
        case 'ANOTHER_DEVICE_IS_LISTENING':
          des = 'Ó nei.\nNúna er annar notandi að hlusta á bókina þína!\nReyndu síðar.';
          break;
        default:
          des = 'Villutexta vantar fyrir ERROR_CODE (' + srv_error.errorcode;
      }
      break;
    case error_kinds.UNDEFINED_ERROR:
      des = 'Óskilgreind villa!';
      break;
  }
  // INTENTION: Til varúðar, þetta á ekki að geta komið upp!
  if (des === '') {
    des = 'Villa ekki skilgreind! ' + srv_error;
  }

  // INTENTION: Set saman villuboðin.
  if (srv_error.error_text) {
    srv_error.error_text = des + '<br>' + srv_error.error_text;
  } else {
    srv_error.error_text = des;
  }

  // console.log('SRV create_srv_error', srv_error)
  return srv_error;
}

// axios.defaults.baseURL = 'https://hlusta.forlagid.is/'
// axios.defaults.baseURL = 'http://localhost:8099/'
// axios.defaults.headers.post['Content-Type'] = 'application/json'
// $.ajaxSetup({
// })
function post(func, data_request, resolve, reject) {
  var baseUrl = 'https://hlusta.forlagid.is/';
  // let baseUrl = 'https://dev.hlusta.forlagid.is/'
  // let baseUrl = 'http://localhost:8099/'
  var path = baseUrl + 'api/ui/';
  if (__WEBPACK_IMPORTED_MODULE_6__storage__["c" /* get_browser_id */]()) {
    data_request.browser_id = __WEBPACK_IMPORTED_MODULE_6__storage__["c" /* get_browser_id */]();
  }
  if (__WEBPACK_IMPORTED_MODULE_6__storage__["d" /* get_user_id */]()) {
    data_request.user_id = __WEBPACK_IMPORTED_MODULE_6__storage__["d" /* get_user_id */]();
  }
  // console.log(data_request)
  try {
    // axios.post(
    //     path + func,
    //     JSON.stringify(data_request), {
    //       'Content-Type': 'application/json'
    //     }
    //   )
    __WEBPACK_IMPORTED_MODULE_5_jquery___default.a.ajax({
      url: path + func,
      type: 'POST',
      data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data_request),
      dataType: 'json'
    }).done(function (api_resp) {
      // console.log('SRV', api_resp)
      if (!api_resp.RESULT) {
        // console.log('SRV A')
        reject(create_srv_error({ kind: error_kinds.JSONError, error_text: 'Vantar RESULT.' }));
      } else if (api_resp.RESULT === 'SUCCESS') {
        if (api_resp.hasOwnProperty('DATA')) {
          // console.log('SRV RESOLVED')
          resolve(api_resp.DATA);
        } else {
          // console.log('SRV B')
          resolve({});
          // reject(create_srv_error({kind: error_kinds.JSONError, error_text: 'Vantar DATA.'}))
        }
      } else if (api_resp.RESULT === 'ERROR') {
        if (!api_resp.ERROR_CODE) {
          // console.log('SRV C')
          reject(create_srv_error({ kind: error_kinds.JSONError, error_text: 'Vantar ERROR_CODE.' }));
        } else {
          // console.log('SRV D')
          reject(create_srv_error({ kind: error_kinds.API_ERROR, error_code: api_resp.ERROR_CODE }));
        }
      }
    }).fail(function (err) {
      // console.log('SRV FAIL', err)
      if (err.response) {
        reject(create_srv_error({ kind: error_kinds.HTTP_ERROR, error_text: 'Statuscode: ' + err.response.status + '<br>Message: ' + err.response.message }));
      } else {
        reject(create_srv_error({ kind: error_kinds.HTTP_ERROR, error_text: err.statusText }));
      }
    });
  } catch (e) {}
}

function signin_browser() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    post('signin_browser', {}, resolve, reject);
  });
}

function signin(username, password) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    post('signin', { username: username, password: password }, resolve, reject);
  });
}

function signout_browser() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    post('signout_browser', {}, resolve, reject);
  });
}

function get_assets() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    post('get_assets', {}, resolve, reject);
  });
}

function get_paths(asset_id) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    post('get_paths/' + asset_id, {}, resolve, reject);
  });
}

function save_current_time(asset_id, path_id, sec_pos) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    post('save_pos/' + asset_id + '/' + path_id + '/' + sec_pos, {}, resolve, reject);
  });
}

/***/ }),

/***/ "LhoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp_body"},[_c('img',{staticClass:"comp_x link",attrs:{"src":"/static/img/X.svg"},on:{"click":function($event){_vm.$emit('show-assets')}}}),_vm._v(" "),_c('div',{staticClass:"comp_title"},[_vm._v("\n      Notandi\n  ")]),_vm._v(" "),_c('div',{staticClass:"comp_userinfo"},[_c('div',[_vm._v("\n      "+_vm._s(_vm.fullname)+"\n      "),_c('br'),_vm._v("\n      "+_vm._s(_vm.username)+"\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('input',{attrs:{"type":"button","value":"ÚTSKRÁ"},on:{"click":_vm.on_signout_click}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf8e658_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Y7Vq");
function injectStyle (ssrContext) {
  __webpack_require__("jllF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf8e658_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_js_modal__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import Vuex from 'vuex'

// import router from './router'


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_js_modal___default.a, { dialog: true });
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  // router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "RSwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp_body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.show_chapters),expression:"!show_chapters"}]},[_c('pre',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"player_data"},[_vm._v("    current_path: "+_vm._s(_vm.current_path)+"\n\n    asset_id PROP: "+_vm._s(_vm.asset_id)+"\n    direct: "+_vm._s(_vm.direct)+"\n\n    is_playing: "+_vm._s(_vm.is_playing)+",\n    next_time_to_save: "+_vm._s(_vm.next_time_to_save)+"\n    ")]),_vm._v(" "),_c('img',{staticClass:"comp_x link",attrs:{"src":"/static/img/X.svg"},on:{"click":function($event){_vm.prepare_hide(); _vm.$emit('show-assets')}}}),_vm._v(" "),_c('img',{staticClass:"player_cover",attrs:{"src":this.image_url}}),_vm._v(" "),_c('div',{staticClass:"player_title"},[_vm._v(_vm._s(_vm.current_path.title))]),_vm._v(" "),_c('div',{staticClass:"player_timeremaining"},[_vm._v(_vm._s(_vm.time_remaining))]),_vm._v(" "),_c('div',{staticClass:"player_slider air centerdiv"},[_c('vue-slider',_vm._b({ref:"slider",on:{"drag-end":_vm.on_drag_end,"drag-start":_vm.on_drag_start},model:{value:(_vm.sec_pos_slider),callback:function ($$v) {_vm.sec_pos_slider=$$v},expression:"sec_pos_slider"}},'vue-slider',_vm.slider_config,false))],1),_vm._v(" "),_c('div',{staticClass:"player_controls"},[_c('img',{staticClass:"link air audio_btn2",attrs:{"src":"/static/img/30_tv.svg"},on:{"click":function($event){_vm.backward(30)}}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_playing),expression:"is_playing"}],staticClass:"link air audio_btn",attrs:{"src":"/static/img/pause.svg"},on:{"click":_vm.on_pause_click}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.is_playing),expression:"!is_playing"}],staticClass:"link air audio_btn",attrs:{"src":"/static/img/play.svg"},on:{"click":_vm.on_play_click}}),_vm._v(" "),_c('img',{staticClass:"link air audio_btn2",attrs:{"src":"/static/img/30_th.svg"},on:{"click":function($event){_vm.forward(30)}}})]),_vm._v(" "),_c('div',{staticClass:"air centerdiv"},[_vm._v(_vm._s(_vm.chapter_title))]),_vm._v(" "),_c('div',{staticClass:"player_toc link",on:{"click":function($event){_vm.show_chapters=true}}},[_vm._v("Efnisyfirlit")]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"dom_player","controls":"controls","width":"100px","height":"50px","webkit-playsinline":"true","playsinline":"true"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_chapters),expression:"show_chapters"}],staticClass:"fullscreen chapters"},[_c('div',{staticClass:"comp_title"},[_vm._v("\n        EFNISYFIRLIT\n    ")]),_vm._v(" "),_c('img',{staticClass:"comp_x link",attrs:{"src":"/static/img/X.svg"},on:{"click":function($event){_vm.show_chapters=false}}}),_vm._v(" "),_c('div',{staticClass:"chapters_list"},_vm._l((_vm.paths),function(path){return _c('div',{staticClass:"chapter link",class:{ chapter_selected: _vm.current_path.path_id === path.path_id}},[_c('div',{on:{"click":function($event){_vm.on_chapter_path_id_selected(path.path_id);_vm.show_chapters=false}}},[_c('div',{staticClass:"chapter_title"},[_vm._v(_vm._s(path.title))]),_vm._v(" "),_c('div',{staticClass:"chapter_bar"},[_c('div',{staticClass:"progress_bar"},[_c('div',{staticClass:"progress_done",style:('width: ' + parseInt(100 * path.sec_chapter_pos / path.sec_chapter_total) + '%;')})]),_vm._v(" "),_c('div',{staticClass:"chapter_time"},[_vm._v(_vm._s(_vm.digital_time(path.sec_chapter_total)))])])])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S3J0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export uiApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stream; });

// const devServer = 'http://dev.hlusta.forlagid.is/'
var proServer = 'https://hlusta.forlagid.is/';
var localServer = 'http://fartolva.snara.is/';

// export let host = (window.location.hostname === 'localhost' || window.location.hostname === 'dev.hlusta.forlagid.is') ? devServer : proServer
var host = '';
switch (window.location.hostname) {
  case 'localhost':
  case 'dev.hlusta.forlagid.is':
    host = proServer;
    // host = devServer
    break;
  case 'fartolva.snara.is':
    host = localServer;
    break;
  default:
    host = proServer;
}
var uiApi = host + 'api/ui/';
var stream = host + 's/';

/***/ }),

/***/ "TsL6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return user; });
/* harmony export (immutable) */ __webpack_exports__["c"] = get_browser_id;
/* harmony export (immutable) */ __webpack_exports__["d"] = get_user_id;
/* harmony export (immutable) */ __webpack_exports__["e"] = set_browser_id;
/* harmony export (immutable) */ __webpack_exports__["f"] = set_user_id;
/* harmony export (immutable) */ __webpack_exports__["b"] = clear;
/* eslint-disable camelcase */
// import * as srv from './srv'

window.abs = {};

var assets = [];
window.abs.assets = assets;

var user = {};
window.abs.user = user;

function get_browser_id() {
  return window.localStorage.b;
}
function get_user_id() {
  return window.localStorage.u;
}

function set_browser_id(browser_id) {
  window.localStorage.b = browser_id;
}
function set_user_id(user_id) {
  window.localStorage.u = user_id;
}

function clear() {
  window.abs.assets = [];
  window.abs.user = {};
  delete window.localStorage.b;
  delete window.localStorage.u;
  console.log(window.abs);
}

/***/ }),

/***/ "UQuu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpRd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__srv__ = __webpack_require__("H+s4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage__ = __webpack_require__("TsL6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable camelcase */


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      assets: __WEBPACK_IMPORTED_MODULE_1__storage__["a" /* assets */],
      test: '',
      asset_id: 'not set',
      show_no_asset_msg: false
    };
  },

  methods: {
    on_click_play: function on_click_play(asset_id, image) {
      this.$emit('set-asset-info', asset_id, image);
      this.$emit('show-player');
    },
    get_assets: function get_assets() {
      var _this = this;

      this.show_no_asset_msg = false;
      __WEBPACK_IMPORTED_MODULE_0__srv__["a" /* get_assets */]().then(function (data) {
        if (data.length === 0) {
          _this.show_no_asset_msg = true;
        } else {
          _this.show_no_asset_msg = false;
        }
        _this.assets = data;
      }).catch(function (srv_err) {
        _this.$emit('dialog-message', srv_err.error_text, function () {});
      });
    },
    render_time_remaining: function render_time_remaining(secs_float) {
      var all_secs = parseInt(secs_float);
      var secs = all_secs % 60;
      var all_mins = (all_secs - secs) / 60;
      var mins = all_mins % 60;
      var hours = (all_mins - mins) / 60;
      var str = '';
      if (hours > 0) {
        str = hours + ' klst. eftir';
      } else if (mins > 0) {
        str = mins + ' m\xEDn. eftir';
      } else if (secs > 5) {
        str = secs + ' sek. eftir';
      } else {
        str = 'lokið';
      }
      return str;
    }
  },
  mounted: function mounted() {
    this.get_assets();
  }
});

/***/ }),

/***/ "Y7Vq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('player',{directives:[{name:"show",rawName:"v-show",value:(_vm.player_visible),expression:"player_visible"}],ref:"player",attrs:{"assetuuid":_vm.player_asset_id},on:{"show-assets":_vm.show_assets,"dialog-message":_vm.dialog_message}}),_vm._v(" "),_c('assets',{directives:[{name:"show",rawName:"v-show",value:(_vm.assets_visible),expression:"assets_visible"}],ref:"assets",on:{"show-player":_vm.show_player,"set-asset-info":_vm.set_asset_info,"show-user":_vm.show_user}}),_vm._v(" "),_c('signin',{directives:[{name:"show",rawName:"v-show",value:(_vm.signin_visible),expression:"signin_visible"}],on:{"dialog-message":_vm.dialog_message,"show-assets":_vm.show_assets}}),_vm._v(" "),_c('sleep',{directives:[{name:"show",rawName:"v-show",value:(_vm.sleep_visible),expression:"sleep_visible"}]}),_vm._v(" "),_c('user',{directives:[{name:"show",rawName:"v-show",value:(_vm.user_visible),expression:"user_visible"}],ref:"user",on:{"show-assets":_vm.show_assets,"show-signin":_vm.show_signin}}),_vm._v(" "),_c('v-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZP1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp_body_signin",staticStyle:{"width":"400px"}},[_vm._m(0),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text","placeholder":"Notandanafn"},domProps:{"value":(_vm.username)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.on_username_enter($event)},"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",attrs:{"type":"password","placeholder":"Lykilorð"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.on_password_enter($event)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('input',{attrs:{"type":"button","value":"INNSKRÁ"},on:{"click":_vm.on_signin_click}})]),_vm._v(" "),_c('h4',{staticStyle:{"margin-top":"30px"}},[_vm._v("Ekkert notandanafn?")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"/static/img/hljodbok-@1x-400.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    Stofnaðu aðgang og kauptu "),_c('a',{staticClass:"link2",attrs:{"href":"https://www.forlagid.is/voruflokkur/hljodbaekur-og-tonlist/streymi/"}},[_vm._v("Hljóðbók - streymi á heimasíðu Forlagsins")]),_vm._v(" og þá birtist bókin í appinu.\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aD/0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sleep"}},[_vm._v("\n  sleep\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gbV2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp_body"},[_c('div',{staticClass:"comp_title"},[_vm._v("\n      BÓKASAFNIÐ MITT\n  ")]),_vm._v(" "),_c('img',{staticClass:"comp_forlagid_logo",attrs:{"src":"/static/img/hvit_fjodur.svg"}}),_vm._v(" "),_c('div',{staticClass:"comp_cmds"},[_c('a',{staticClass:"link",attrs:{"href":"https://www.forlagid.is/voruflokkur/hljodbaekur-og-tonlist/streymi/"}},[_vm._v("Verslun")]),_vm._v("\n     \n    "),_c('span',{staticClass:"link",on:{"click":function($event){_vm.$emit('show-user')}}},[_vm._v("Notandi")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_no_asset_msg),expression:"show_no_asset_msg"}],staticClass:"comp_no_assets"},[_c('h4',{staticStyle:{"margin-top":"30px"}},[_vm._v("Engar bækur?")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"comp_assets"},_vm._l((_vm.assets),function(asset){return _c('div',{staticClass:"asset link",on:{"click":function($event){_vm.on_click_play(asset.asset_id, asset.image)}}},[_c('img',{staticClass:"asset_cover",attrs:{"src":'https://hlusta.forlagid.is/i/' + asset.image + '/cover-70@1x.png'}}),_vm._v(" "),_c('span',{staticClass:"asset_title"},[_vm._v(_vm._s(asset.title))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"asset_author"},[_vm._v(_vm._s(asset.author))]),_c('br'),_vm._v(" "),_c('div',{staticClass:"asset_bar"},[_c('div',{staticClass:"progress_bar"},[_c('div',{staticClass:"progress_done",style:('width: ' + parseInt(100 * asset.sec_book_pos / asset.sec_book_total) + '%;')})]),_vm._v(" "),_c('span',{staticClass:"asset_time_ramaining"},[_vm._v(_vm._s(_vm.render_time_remaining(asset.sec_book_total - asset.sec_book_pos))+" ")])])])}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n      Kauptu "),_c('a',{staticClass:"link2",attrs:{"href":"https://www.forlagid.is/voruflokkur/hljodbaekur-og-tonlist/streymi/"}},[_vm._v("Hljóðbók - streymi á heimasíðu Forlagsins")]),_vm._v(" og þá birtist bókin í appinu.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i1Mp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jllF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jyJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__("qgpy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d41e20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__("LhoA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d41e20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qgpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage__ = __webpack_require__("TsL6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__srv__ = __webpack_require__("H+s4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable camelcase */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      fullname: ''
    };
  },

  methods: {
    setup: function setup() {
      this.username = __WEBPACK_IMPORTED_MODULE_0__storage__["g" /* user */].username;
      this.fullname = __WEBPACK_IMPORTED_MODULE_0__storage__["g" /* user */].fullname;
    },
    on_signout_click: function on_signout_click() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__srv__["f" /* signout_browser */]().then(function (data) {
        console.log(data.fullname);
        __WEBPACK_IMPORTED_MODULE_0__storage__["b" /* clear */]();
        _this.$emit('show-signin');
      }).catch(function (srv_err) {
        _this.$emit('dialog-message', srv_err.error_text, function () {});
      });
    }
  },
  mounted: function mounted() {
    this.username = __WEBPACK_IMPORTED_MODULE_0__storage__["g" /* user */].username;
    this.fullname = __WEBPACK_IMPORTED_MODULE_0__storage__["g" /* user */].fullname;
  }
});

/***/ }),

/***/ "rOBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__srv__ = __webpack_require__("H+s4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage__ = __webpack_require__("TsL6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable camelcase */


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },

  methods: {
    on_username_enter: function on_username_enter() {
      this.$refs.password.focus();
    },
    on_password_enter: function on_password_enter() {
      this.sign_in();
    },
    on_signin_click: function on_signin_click() {
      this.sign_in();
    },
    sign_in: function sign_in() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__srv__["d" /* signin */](this.username, this.password).then(function (data) {
        console.log(data.fullname);
        __WEBPACK_IMPORTED_MODULE_1__storage__["e" /* set_browser_id */](data.browser_id);
        __WEBPACK_IMPORTED_MODULE_1__storage__["f" /* set_user_id */](data.user_id);
        __WEBPACK_IMPORTED_MODULE_1__storage__["g" /* user */].username = data.username;
        __WEBPACK_IMPORTED_MODULE_1__storage__["g" /* user */].fullname = data.fullname;
        _this.username = '';
        _this.password = '';
        _this.$emit('show-assets');
      }).catch(function (srv_err) {
        _this.$emit('dialog-message', srv_err.error_text, function () {});
      });
    }
  }
});

/***/ }),

/***/ "rwDq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__ = __webpack_require__("yFA6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eefa7fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__ = __webpack_require__("RSwC");
function injectStyle (ssrContext) {
  __webpack_require__("i1Mp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eefa7fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vKeq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sleep_vue__ = __webpack_require__("6/c+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd1ce78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sleep_vue__ = __webpack_require__("aD/0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sleep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd1ce78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sleep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Player__ = __webpack_require__("rwDq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Assets__ = __webpack_require__("+KtI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Signin__ = __webpack_require__("Asuo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Sleep__ = __webpack_require__("vKeq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_User__ = __webpack_require__("jyJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__srv__ = __webpack_require__("H+s4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__storage__ = __webpack_require__("TsL6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable camelcase */








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'player': __WEBPACK_IMPORTED_MODULE_0__components_Player__["a" /* default */],
    'assets': __WEBPACK_IMPORTED_MODULE_1__components_Assets__["a" /* default */],
    'signin': __WEBPACK_IMPORTED_MODULE_2__components_Signin__["a" /* default */],
    'sleep': __WEBPACK_IMPORTED_MODULE_3__components_Sleep__["a" /* default */],
    'user': __WEBPACK_IMPORTED_MODULE_4__components_User__["a" /* default */]
  },
  data: function data() {
    return {
      player_visible: false,
      player_asset_id: '',
      assets_visible: false,
      signin_visible: false,
      sleep_visible: false,
      user_visible: false
    };
  },

  methods: {
    dialog_message: function dialog_message(msg, callback) {
      var _this = this;

      if (document.activeElement) {
        document.activeElement.blur();
      }
      this.$modal.show('dialog', {
        // title: `(${title})`,
        // title: 'SKILABOÐ',
        // text: `<pre>${msg}</pre>`,
        text: msg,
        width: '600px',
        buttons: [{
          title: 'Í lagi',
          handler: function handler() {
            callback();
            _this.$modal.hide('dialog');
          }
        }]
      });
    },
    hide_all: function hide_all() {
      this.player_visible = false;
      this.assets_visible = false;
      this.signin_visible = false;
      this.sleep_visible = false;
      this.user_visible = false;
    },
    set_asset_info: function set_asset_info(asset_id, image) {
      // Til að triggera breyginu, til að fá kerfið til að load aftur kafla uppl, gert til að spilarinn merki sig sem núverand code hlustanda
      // console.log('BBBBBBBB')
      // this.player_asset_id = 'NONE'
      // this.player_asset_id = asset_id
      this.$refs.player.setup_paths(asset_id, image);
    },
    show_player: function show_player(asset) {
      // console.log('APP show_player')
      this.hide_all();
      this.player_visible = true;
    },
    show_assets: function show_assets() {
      // console.log('APP show_assets')
      this.$refs.assets.get_assets();
      this.hide_all();
      this.assets_visible = true;
    },
    show_signin: function show_signin() {
      console.log('APP show_signin');
      this.hide_all();
      this.signin_visible = true;
    },
    show_sleep: function show_sleep() {
      // console.log('APP show_sleep')
      this.hide_all();
      this.sleep_visible = true;
    },
    show_user: function show_user() {
      // console.log('APP show_user')
      this.$refs.user.setup();
      this.hide_all();
      this.user_visible = true;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // INTENTION: Ath hvort notandinn sé skráður inn, og staðfesta.
    if (__WEBPACK_IMPORTED_MODULE_6__storage__["c" /* get_browser_id */]() && __WEBPACK_IMPORTED_MODULE_6__storage__["d" /* get_user_id */]()) {
      __WEBPACK_IMPORTED_MODULE_5__srv__["e" /* signin_browser */]().then(function (data) {
        console.log('1');
        __WEBPACK_IMPORTED_MODULE_6__storage__["g" /* user */].username = data.username;
        __WEBPACK_IMPORTED_MODULE_6__storage__["g" /* user */].fullname = data.fullname;
        _this2.show_assets();
      }).catch(function (srv_err) {
        console.log('2', srv_err);
        _this2.show_signin();
      });
    } else {
      this.show_signin();
    }
  }
});

/***/ }),

/***/ "yFA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__srv__ = __webpack_require__("H+s4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url__ = __webpack_require__("S3J0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hls_js__ = __webpack_require__("YT+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hls_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hls_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storage__ = __webpack_require__("TsL6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import * as storage from '../storage'
/* eslint-disable camelcase */






function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
}
var dom_player = void 0;
var hls = void 0;
// console.log('script in Player.vue')
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a
  },
  watch: {},
  data: function data() {
    return {
      // log: '',
      show_chapters: false,
      paths: [],
      paths_by_id: {},
      current_path: {},
      direct: false,
      image_url: '',
      asset_id: '',
      setup_events_done: false,

      time_remaining: '',
      do_update_ui: true,
      is_playing: false,
      sec_pos_slider: 0,
      duration: 0,
      chapter_title: '',
      chapter_id: '',
      next_chapter_id: '',
      next_chapter_title: '',
      next_time_to_save: 0,
      play_allowed: false,
      slider_config: {
        value: 1,
        width: 300,
        height: 6,
        dotHeight: 20,
        dotWidth: 20,
        min: 0,
        max: 25,
        // interval: 1,
        disabled: false,
        show: true,
        speed: 0.3,
        reverse: false,
        lazy: true,
        tooltip: 'hover',
        piecewise: false,
        formatter: function formatter(all_secs) {
          var secs = all_secs % 60;
          var all_mins = (all_secs - secs) / 60;
          var mins = all_mins % 60;
          var hours = (all_mins - mins) / 60;
          if (hours > 0) {
            return pad(hours, 2) + ':' + pad(mins, 2) + ':' + pad(secs, 2);
          } else {
            return pad(mins, 2) + ':' + pad(secs, 2);
          }
        },

        processStyle: {
          backgroundColor: '#9f0811'
        },
        tooltipStyle: {
          backgroundColor: '#9f0811',
          borderColor: '#9f0811'
        },
        // tooltipStyle: [
        //   {
        //     backgroundColor: '#9f0811',
        //     borderColor: '#9f0811'
        //   }
        // ],
        // bgStyle: {
        //   backgroundColor: '#660'
        // },
        clickable: false

      }
    };
  },
  mounted: function mounted() {
    // console.log('mounted in Player.vue')
    dom_player = document.getElementById('dom_player');
    window.p = dom_player;
    if (dom_player.canPlayType('application/vnd.apple.mpegurl') === 'probably' || dom_player.canPlayType('application/vnd.apple.mpegurl') === 'maybe') {
      this.direct = true;
    } else {
      this.direct = false;
    }
  },

  methods: {
    // set_current_path_by_id (path_id) {
    //   this.current_path_index = 0
    //   this.current_path = this.paths.find(p => {
    //     this.current_path_index += 1
    //     return p.path_id === path_id
    //   })
    //   if (!this.current_path) {
    //     this.current_path = {}
    //   }
    // },
    // set_next_current_path () {
    //   this.current_path_index = this.current_path_index + 1
    //   if (this.paths.length === this.current_path_index) {
    //     this.current_path = {}
    //   } else {
    //     this.current_path = this.paths[this.current_path_index]
    //   }
    // },
    // play_path_current_path () {
    //   dom_player.pause()
    // },
    //  select_chapter_from_chapters (chapter_id) {
    //    this.show_chapters = false
    //    this.sec_pos = 0
    //    // this.next_time_to_save = 0
    //    this.get_chapter_data(this.asset_id, chapter_id, this.play)
    //  },
    on_chapter_path_id_selected: function on_chapter_path_id_selected(path_id) {
      // this.log = 'on_chapter_path_id_selected: new path' + path_id
      this.current_path = this.paths_by_id[path_id];
      if (this.current_path.sec_chapter_total < this.current_path.sec_chapter_pos + 5) {
        this.current_path.sec_chapter_pos = 0;
      }
      this.setup();
    },
    setup_paths: function setup_paths(asset_id, image) {
      var _this = this;

      this.asset_id = asset_id;
      this.image_url = 'https://hlusta.forlagid.is/i/' + image + '/cover-300@1x.png';
      __WEBPACK_IMPORTED_MODULE_0__srv__["b" /* get_paths */](this.asset_id).then(function (data) {
        _this.paths = data.paths;
        _this.paths_by_id = {};
        var last_path;
        for (var i = 0; i < data.paths.length; i += 1) {
          var p = data.paths[i];
          _this.paths_by_id[p.path_id] = p;
          if (last_path) {
            last_path.next_path_id = p.path_id;
            _this.paths_by_id[last_path.path_id].next_path_id = p.path_id;
          }
          last_path = p;
        }
        if (data.current_path_id) {
          _this.current_path = _this.paths_by_id[data.current_path_id];
        } else {
          _this.current_path = _this.paths[0];
        }
        _this.setup();
      }).catch(function (srv_err) {
        _this.$emit('dialog-message', srv_err.error_text, function () {});
      });
    },
    prepare_hide: function prepare_hide() {
      this.pause();
      this.play_allowed = false;
      // dom_player.src = ''
      // dom_player.load()
    },
    on_pause_click: function on_pause_click() {
      this.do_update_ui = true;
      this.pause();
    },
    pause: function pause() {
      dom_player.pause();
    },
    on_play_click: function on_play_click() {
      this.play_allowed = true;
      this.do_update_ui = true;
      this.play();
    },
    play: function play() {
      if (this.play_allowed) {
        dom_player.play();
      }
    },
    save_current_time: function save_current_time() {
      var _this2 = this;

      // this.next_time_to_save = this.sec_pos + 5
      this.next_time_to_save = dom_player.currentTime + 5;
      var the_time = parseInt(dom_player.currentTime);
      __WEBPACK_IMPORTED_MODULE_0__srv__["c" /* save_current_time */](this.asset_id, this.current_path.path_id, the_time).then(function () {
        _this2.current_path.sec_chapter_pos = the_time;
      }).catch(function (srv_err) {
        // console.log(srv_err)
        if (srv_err.error_code === 'ANOTHER_DEVICE_IS_LISTENING') {
          _this2.pause();
          _this2.$emit('dialog-message', 'Ó nei.<br>Núna er annar notandi er að hlusta á bókina þína.  <br>Reyndu síðar.', function () {
            _this2.$emit('get-assets');
            _this2.$emit('show-assets');
          });
        }
      });
    },
    render_time_remaining: function render_time_remaining(secs_float) {
      var all_secs = parseInt(secs_float);
      var secs = all_secs % 60;
      var all_mins = (all_secs - secs) / 60;
      var mins = all_mins % 60;
      var hours = (all_mins - mins) / 60;
      var str = '';
      if (hours > 0) {
        str = hours + ' klst. eftir';
      } else if (mins > 0) {
        str = mins + ' m\xEDn. eftir';
      } else if (secs > 0) {
        str = secs + ' sek. eftir';
      }
      return str;
    },
    setup_events: function setup_events() {
      var _this3 = this;

      if (!this.setup_events_done) {
        this.setup_events_done = true;
        // dom_player.addEventListener("ended", new_chapter);
        dom_player.addEventListener('play', function () {
          _this3.is_playing = true;
        });
        dom_player.addEventListener('pause', function (e) {
          window.e = e;
          // console.log('paused')
          if (_this3.do_update_ui) {
            _this3.is_playing = false;
          }
        });
        // dom_player.addEventListener('loadedmetadata', (e, e2) => {
        //   console.log('loadedmetadata', e, e2)
        // })
        dom_player.addEventListener('durationchange', function (e, e2) {
          _this3.duration = dom_player.duration;
          if (_this3.sec_pos_slider > parseInt(dom_player.duration)) {
            _this3.sec_pos_slider = parseInt(dom_player.duration);
          }
          _this3.slider_config.max = parseInt(dom_player.duration);
          // this.log = `durationchange: dom_player.duration:${parseInt(dom_player.duration)} \n` + this.log
        });
        dom_player.addEventListener('timeupdate', function (e, e2) {
          if (!dom_player.paused) {
            _this3.sec_pos_slider = parseInt(dom_player.currentTime);
            _this3.time_remaining = _this3.render_time_remaining(_this3.duration - dom_player.currentTime);
            if (_this3.next_time_to_save < dom_player.currentTime) {
              _this3.save_current_time();
            }
          }
          if (parseInt(dom_player.currentTime) !== _this3.last_timeupdate) {
            // this.log = `currentTime:${parseInt(dom_player.currentTime)}, next_time_to_save:${parseInt(this.next_time_to_save)} \n` + this.log
          }
          _this3.last_timeupdate = parseInt(dom_player.currentTime);
        });
        dom_player.addEventListener('ended', function () {
          // console.log('ended')
          // this.log = 'in dom_player event ended\n' + this.log
          _this3.do_update_ui = false;
          // console.log(this.current_path)
          if (_this3.current_path.next_path_id) {
            _this3.current_path = _this3.paths_by_id[_this3.current_path.next_path_id];
            _this3.current_path.sec_chapter_pos = 0;
            _this3.sec_pos_slider = 0;
            _this3.next_time_to_save = 0;
            _this3.setup();
          }
        });
      }
    },
    setup: function setup() {
      var _this4 = this;

      if (this.direct) {
        dom_player.setAttribute('autoplay', 'true');
        dom_player.currentTime = 0;
        dom_player.setAttribute('src', this.get_url());
        dom_player.oncanplay = function () {
          dom_player.currentTime = _this4.current_path.sec_chapter_pos;
          _this4.next_time_to_save = _this4.current_path.sec_chapter_pos + 5;
          _this4.sec_pos_slider = parseInt(_this4.current_path.sec_chapter_pos);
          dom_player.play();
        };
      } else {
        if (__WEBPACK_IMPORTED_MODULE_2_hls_js___default.a.isSupported()) {
          if (!hls) {
            hls = new __WEBPACK_IMPORTED_MODULE_2_hls_js___default.a();
          }
          hls.loadSource(this.get_url());
          hls.attachMedia(dom_player);
          hls.on(__WEBPACK_IMPORTED_MODULE_2_hls_js___default.a.Events.MANIFEST_PARSED, function () {
            dom_player.play();
          });
          // this.log = `playing from sec_chapter_pos:${this.current_path.sec_chapter_pos} \n` + this.log
          dom_player.currentTime = this.current_path.sec_chapter_pos;
          this.next_time_to_save = this.current_path.sec_chapter_pos + 5;
          // this.log = `setting next_time_to_save to:${this.next_time_to_save} \n` + this.log
        }
      }
      this.setup_events();
    },
    forward: function forward(sec) {
      if (dom_player.currentTime < dom_player.duration - 2) {
        var new_time = dom_player.currentTime + sec;
        if (dom_player.duration - 2 <= new_time) {
          new_time = dom_player.duration - 2;
        }
        dom_player.currentTime = new_time;
        this.next_time_to_save = new_time;
      }
    },
    backward: function backward(sec) {
      var new_time = dom_player.currentTime - sec;
      if (new_time < 0) {
        new_time = 0;
      }
      this.next_time_to_save = new_time;
      dom_player.currentTime = new_time;
    },
    on_drag_end: function on_drag_end(e) {
      // this.log = `on_drag_end: e:${parseInt(e.getValue())} \n` + this.log
      // this.log = `on_drag_end: dom_player.currentTime:${dom_player.currentTime} \n` + this.log
      // console.log(dom_player.currentTime, parseInt(e.getValue()))
      this.next_time_to_save = parseInt(e.getValue());
      dom_player.pause();
      dom_player.currentTime = parseInt(e.getValue());
      dom_player.play();
      // this.log = `on_drag_end: e:${parseInt(e.getValue())} \n` + this.log
      // this.log = `on_drag_end: dom_player.currentTime:${dom_player.currentTime} \n` + this.log

      // console.log(dom_player.currentTime, parseInt(e.value))
      // this.play()
      // console.log(dom_player.currentTime, parseInt(e.value))
    },
    on_drag_start: function on_drag_start(e) {
      // console.log(e.value)
      // this.pause()
    },
    get_url: function get_url() {
      return '' + __WEBPACK_IMPORTED_MODULE_1__url__["a" /* stream */] + __WEBPACK_IMPORTED_MODULE_4__storage__["c" /* get_browser_id */]() + '/' + this.current_path.path_id + '/s.m3u8';
    },
    str_pad_left: function str_pad_left(string, pad, length) {
      return (new Array(length + 1).join(pad) + string).slice(-length);
    },
    digital_time: function digital_time(secs_total) {
      var hours = Math.floor(secs_total / 3600);
      var mins = Math.floor(secs_total % 3600 / 60);
      var secs = secs_total % 3600 % 60;
      return this.str_pad_left(hours, '0', 2) + ':' + this.str_pad_left(mins, '0', 2) + ':' + this.str_pad_left(secs, '0', 2);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cd82bdc1fe85ec7427c6.js